import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

//
import Moment from "react-moment";
import { Dropdown } from "react-bootstrap";

//
import LogoutModal from "./LogoutModal";
import NothingToShow from "../../components/general/NothingToShow";

//
import User from "../../assets/img/user.png";

function Navbar({ setSidebar, user, notifications }) {
  let navigate = useNavigate();
  const [show, setShow] = useState(false);

  // const [notifications, setNotifications] = useState({
  //   new_messages: 2,
  //   notifications: [
  //     {
  //       title: "Reminder",
  //       subject: "Hi User, don’t forget today is your treatment time.",
  //       created_at: "02.30 PM",
  //       new_message: true,
  //     },
  //     {
  //       title: "Report Succes",
  //       subject: "Your report succes created succesfully.",
  //       created_at: "02.30 PM",
  //       new_message: true,
  //     },
  //     {
  //       title: "Reminder",
  //       subject: "Hi User, don’t forget today is your treatment time.",
  //       created_at: "yesterday",
  //       new_message: false,
  //     },
  //     {
  //       title: "Report Succes",
  //       subject: "Your report succes created succesfully.",
  //       created_at: "2 Day Ago",
  //       new_message: false,
  //     },
  //   ],
  // });

  return (
    <div id="navbar">
      <i
        className="las la-grip-lines d-block d-xl-none text-black menu-icon"
        onClick={setSidebar}
      />
      <div className="info">
        {!!user.id && (
          <>
            {/* Notification */}
            <Dropdown className="notification" align="end">
              <Dropdown.Toggle
                className={notifications.length ? "have-new" : ""}
              >
                <i className="las la-bell"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <header className={notifications.length ? "have-new" : ""}>
                  <div className="holder">
                    <p className="fw-extra-bolder">Notifications</p>
                    {!!notifications.length && (
                      <span className="new-messages-counter">
                        {notifications.length}
                      </span>
                    )}
                    {/* {notifications.length ? (
                  <span className="new-messages-counter">
                    {notifications.length}
                  </span>
                ) : (
                  <small className="fw-bolder text-info pointer">
                    Mark all as read
                  </small>
                )} */}
                  </div>
                </header>
                {notifications.length ? (
                  <>
                    <div className="notifications-content">
                      {notifications.slice(0, 2).map((item, index) => (
                        <div
                          className="item-holder have-new"
                          // className={`item-holder ${
                          //   item.new_message ? "have-new" : ""
                          // }`}
                          key={index}
                        >
                          <div className="item">
                            <div className="title-box">
                              <span
                                // className={`icon-box ${
                                //   item.title === "Reminder" ? "warning" : "success"
                                // }`}
                                className="icon-box warning"
                              >
                                <i
                                  className="las la-info-circle"
                                  // className={`las ${
                                  //   item.title === "Reminder"
                                  //     ? "la-info-circle"
                                  //     : "la-check"
                                  // }`}
                                ></i>
                              </span>
                              <div>
                                {item.symbol ? (
                                  <Link
                                    to={`/app/coin-detail/${item.symbol}`}
                                    className="fw-bolder"
                                  >
                                    {item.title}
                                  </Link>
                                ) : (
                                  <p className="fw-bolder text-dark">
                                    {item.title}
                                  </p>
                                )}
                                <small className="text-muted">
                                  {item.message}
                                </small>
                              </div>
                            </div>

                            <div className="time-box">
                              <small>
                                {" "}
                                <Moment utc fromNow>
                                  {item.created_at}
                                </Moment>
                              </small>
                              <small className="new-message-indicator"></small>
                              {/* {item.new_message && (
                        <small className="new-message-indicator"></small>
                      )} */}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <Dropdown.Item onClick={() => navigate("notifications")}>
                      <small>See all notifications</small>
                      <i className="las la-angle-right"></i>
                    </Dropdown.Item>
                  </>
                ) : (
                  <NothingToShow text="Nothing to show" />
                )}
              </Dropdown.Menu>
            </Dropdown>
            {/* User */}
            <Dropdown className="person">
              <Dropdown.Toggle className="no-border">
                <img
                  src={user.photo || User}
                  alt="user"
                  className="rounded-full"
                />
                <div>
                  <p className="mb-0 truncate">
                    {user.first_name
                      ? `${user.first_name} ${user.last_name}`
                      : user.email}
                  </p>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <div className="dropdown-header">
                  <img src={User} alt="user" className="rounded-full" />
                  <div>
                    <small className="fw-bolder text-black text-center">
                      {user.first_name} {user.last_name}
                    </small>
                    <small className="text-center">{user.email}</small>
                  </div>
                </div>
                <div className="content">
                  <Dropdown.Item onClick={() => navigate("account")}>
                    <i className="icon icon-user"></i>
                    your profile
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => setShow(true)}
                    className="text-danger"
                  >
                    <i className="icon icon-logout text-danger"></i>
                    sign out
                  </Dropdown.Item>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </>
        )}
      </div>
      <LogoutModal show={show} setShow={(status) => setShow(status)} />
    </div>
  );
}

Navbar.propTypes = {
  setSidebar: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  notifications: state.userReducer.notifications,
});

export default connect(mapStateToProps)(Navbar);
